import { useEffect } from 'react'
import {useNavigate, useParams} from "react-router-dom"
import { useRecoilState } from 'recoil';
import { selectedTaskState, selectedModelState, namespaceState } from '../recoil/atoms';
import useApi from '../services/useApi';

export default function ProtectRoute({children}){
    const urlParams=useParams();
    const [, setSelectedTask] = useRecoilState(selectedTaskState);
    const [, setSelectedModel]=useRecoilState(selectedModelState);
    const [nsState,]=useRecoilState(namespaceState);
    const userId=JSON.parse(localStorage.getItem("account")).id;
    const navigate = useNavigate();

    useEffect(()=>{
        if(urlParams.taskId){
            useApi.get("/ngp/fl/task/"+urlParams.taskId+'?namespaceId='+nsState.id).then((res)=>{
                setSelectedTask(res.data)
            }).catch(err=>{
                alert("유효하지 않은 Task ID 입니다.")
                return window.location.href='/task-list';
            });
        }else if(urlParams.modelId){
            useApi.get('/ngp/modelreg/mm/model/v1/model?modelId='+urlParams.modelId+'&namespaceId='+nsState.id+'&userId='+userId)
            .then((res) => {
                setSelectedModel(res.data);
            })
        }
    },[navigate])
    
    return children
};